module.exports = __webpack_public_path__ + "img/1488403758.bb3dc66b.jpg";